import { useMemo } from "react";
import { useCameras } from "@src/features/cameras";
import { useSelectedSiteStore } from "@src/stores/selected-site-store";
import { getCameraKeyString, isLegacyAppCamera } from "@src/utils/key-parser";

export function useSiteCameraKeys() {
  const { data: cameras } = useCameras();
  const selectedSiteId = useSelectedSiteStore((s) => s.selectedSiteId);

  const supportedCameras = useMemo(() => {
    if (!cameras) return [];
    return cameras.filter((camera) => !isLegacyAppCamera(camera));
  }, [cameras]);

  const siteCameras = useMemo(() => {
    if (!selectedSiteId) return [];
    return supportedCameras.filter((c) => c.site.id === selectedSiteId);
  }, [supportedCameras, selectedSiteId]);

  const cameraKeys = useMemo(() => {
    return siteCameras.map((c) => getCameraKeyString(c)).filter(Boolean);
  }, [siteCameras]);

  return { cameras, supportedCameras, siteCameras, cameraKeys, selectedSiteId };
}
